import { Form, useAuthProvider, useSafeSetState, useTranslate } from 'ra-core'
import * as React from 'react'
import { FormDataConsumer, useNotify } from 'react-admin'
import { useLocation, useNavigate } from 'react-router-dom'

import AuthFormSection from './AuthFormSection'
import EmailInput from './EmailInput'
import FormCard from './FormCard'
import { useDocumentTitle } from '../../App'
import { LoginPage } from '../../resources/common/login'

const ResetForm = () => {
  const [isLoading, setIsLoading] = useSafeSetState(false)
  const translate = useTranslate()
  const notify = useNotify()
  const navigate = useNavigate()
  const authProvider = useAuthProvider()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const defaultEmail = params.get('email') || ''

  const submit = (values) => {
    setIsLoading(true)
    authProvider.resetEmail(values.username).finally(() => {
      notify(translate('mymove.login.resetEmailSent') + ' ' + values.username)
      navigate(LoginPage.path + '?email=' + encodeURIComponent(values.username), { replace: true })
      setIsLoading(false)
    })
  }

  return (
    <Form onSubmit={submit} noValidate sx={{ paddingBottom: '8px' }} disableInvalidFormNotification>
      <FormDataConsumer>
        {({ formData }) => (
          <AuthFormSection
            isLoading={isLoading}
            disabled={isLoading}
            submitText="mymove.login.sendResetLink"
            linkTo={LoginPage.path + '?email=' + encodeURIComponent(formData.username || defaultEmail)}
            linkText="mymove.login.iKnowMyPassword"
          >
            <EmailInput defaultValue={defaultEmail} disabled={isLoading} />
          </AuthFormSection>
        )}
      </FormDataConsumer>
    </Form>
  )
}

const ResetPage = () => {
  useDocumentTitle('Reset password')
  return (
    <FormCard>
      <ResetForm />
    </FormCard>
  )
}
ResetPage.path = '/reset-password'

export default ResetPage
